import React, { useEffect, useRef, useState } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import { FormControl } from '@mui/material'
import Select, { SingleValue } from 'react-select'
import { SelectChangeEvent } from '@mui/material/Select'
import { useTranslation } from 'react-i18next'
import { status as statusItems } from '../../utils/constants'
import StatusTag from './TagStatus'
import { ActeurAction } from '../../types/actorActionTypes'
import { selectUsername } from '../../redux/keycloak/keycloakSelectors'
import { useSelector } from 'react-redux'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'

interface SelectStatusProps {
  value: string
  onChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void
  actor?: ActeurAction
  disablePortalMenu?: boolean
  /** Hide floating label when a parent FormField already shows one. */
  hideLabel?: boolean
}

const SelectStatus: React.FC<SelectStatusProps> = ({
  value,
  onChange,
  actor,
  disablePortalMenu = false,
  hideLabel = true,
}) => {
  const menu = useExclusiveMenu(!disablePortalMenu)
  const username = useSelector(selectUsername)
  const { t } = useTranslation()

  const containerRef = useRef<HTMLDivElement | null>(null)


  const filteredStatus = statusItems.filter((statut) => {
    if (value === 'Terminé' && statut === 'Terminé') {
      return true
    }
    if (actor && statut === 'Terminé') {
      return (
        username?.toLocaleLowerCase() ===
        actor?.RASCI?.Approbateur?.[0]?.toLocaleLowerCase()
      )
    }
    return true
  })

  const options = filteredStatus.map((statut) => ({
    value: statut,
    label: t(statut, { defaultValue: statut }),
  }))

  const selectedOption = options.find((opt) => opt.value === value) || null

  const handleSelectChange = (
    selected: SingleValue<{ value: string; label: string }>
  ) => {
    onChange(
      {
        target: { name: 'status', value: selected ? selected.value : '' },
      } as SelectChangeEvent<string>,
      null
    )
  }

  const formatOptionLabel = (option: { value: string; label: string }) => (
    <StatusTag value={option.value} />
  )

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      {!hideLabel ? (
        <label
          style={{
            position: 'absolute',
            top: '-8px',
            left: '12px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.6)',
            backgroundColor: 'white',
            padding: '0 4px',
            zIndex: 60,
          }}
        >
          {t('status')}
        </label>
      ) : null}
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select<{ value: string; label: string }, false>
          value={selectedOption}
          onChange={handleSelectChange}
          options={options}
          placeholder={t('status')}
          formatOptionLabel={formatOptionLabel}
          {...menu}
          styles={incyiaSelectStyles}
          isMulti={false}
        />
      </FormControl>
    </div>
  )
}

export default SelectStatus
